<template>
  <div class="AdminPermission">
    <box :title="$t('permissionList')">
      <div class="pa-2">
        <div class="d-flex justify-space-around">
          <strong>{{ $t("group") }} : {{ adminInfo.Name || "" }}</strong>
          <strong
            >{{ $t("personel") }} : {{ adminInfo.personName || "" }}</strong
          >
        </div>
        <v-divider class="my-2"></v-divider>
        <v-row>
          <v-col
            class="pa-0"
            cols="12"
            sm="6"
            v-for="(item, index) in permissionList"
            :key="index"
          >
            <v-checkbox
              multiple
              hide-details
              :value="item.permissionID"
              :label="item.permissionName"
              v-model="selectedPermissions"
              class="checkbox-rtl"
            />
          </v-col>
        </v-row>
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="changePermission">{{
          $t("Pattern.changePermission")
        }}</v-btn>
      </v-card-actions>
    </box>
  </div>
</template>

<script>
import ResultType from "../../../model/ResultType";
export default {
  data() {
    return {
      args: null,
      adminInfo: {},
      permissionList: [],
      selectedPermissions: [],
    };
  },
  mounted() {
    this.pageLoad();
  },
  methods: {
    pageLoad() {
      this.args = this.$route.query;
      var sectionid = this.args.id;
      this.$store
        .dispatch("sections/GetWebSectionsAdmins", { sectionid })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            if (result.data.Table.length > 0) {
              var admin = result.data.Table[0];
              this.adminInfo = admin;
            }
          }
        });
      this.loadPermission();
      this.setPermission(sectionid);
    },
    setPermission(sectionid) {
      this.$store
        .dispatch("sections/GetWebSectionDetail", { sectionid })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            if (result.data.Table.length > 0) {
              var strPermission = result.data.Table[0].adminPermission;
              var permissions = Array.from(strPermission);
              //console.log(permissions);
              permissions.forEach((element, i) => {
                if (element == 1) {
                  this.selectedPermissions.push(i);
                }
              });
            }
          }
        });
    },
    loadPermission() {
      //chkPermission.DataSource = Permission.AdminPermissionList();
      this.$store.dispatch("GetAdminPermissionList").then((result) => {
        ////console.log(result);
        if (result.type === ResultType.success) {
          this.permissionList = result.data.Table;
        }
      });
    },
    changePermission() {
      var permissions = Array(100).fill(0);
      this.selectedPermissions.forEach((element) => {
        permissions[Number(element)] = 1;
      });

      var strPermission = permissions.join("");
      ////console.log(strPermission);

      var UpdateWebSectionParams = {
        ismanager:0,
        sectionid: this.args.id,
        adminpermission: strPermission,
      };
      this.$store
        .dispatch("sections/UpdateWebSectionProperties", { UpdateWebSectionParams })
        .then((result) => {
          //console.log(result);

          if (result.type == ResultType.success) {
            var query = {
              id: this.args.id,
              adminInfo:this.adminInfo
            };
            this.$router.push({ name: "pageApproveCode", query: query });
          }
        });
    },
  },
};
</script>

<style>
</style>